import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import cn from 'classnames'
import { css, StyleSheet } from 'aphrodite'

export default function Modal({ isActive, children, onClose }) {
    useEffect(() => {
        const handleKeyboard = (event) => {
            if (event.key === 'Escape') {
                onClose()
            }
        }

        window.addEventListener('keydown', handleKeyboard)
        return () => {
            window.removeEventListener('keydown', handleKeyboard)
        }
    }, [onClose])

    if (!isActive) return null

    return createPortal(
        <div className={cn(css(styles.modal))}>
            <div className={css(styles.overlay)} onClick={onClose} />

            <div className={css(styles.modalCard)}>
                <button className={css(styles.closeButton)} onClick={onClose}>&times;</button>
                <div className={css(styles.modalBody)}>
                    {children}
                </div>
            </div>
        </div>,
        document.querySelector('#modals-root'),
    )
}

const styles = StyleSheet.create({
    modal: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
        transition: 'opacity 0.3s ease-in-out',
    },
    overlay: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.5)',
    },
    modalCard: {
        position: 'relative',
        background: '#fff',
        borderRadius: '10px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        width: '90%',
        maxWidth: '500px',
        maxHeight: '80vh',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
    },
    closeButton: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        border: 'none',
        background: 'transparent',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#555',
        ':hover': {
            color: '#000',
        },
    },
    modalBody: {
        flexGrow: 1,
        overflowY: 'auto',
        padding: '10px 0',
        fontSize: '16px',
        color: '#333',
    },
})
